export const SET_INFO = 'SET_INFO'
export const SET_OWNER = 'SET_OWNER'
export const SET_CATEGORY = 'SET_CATEGORY'
export const SET_REGISTER_REFERENCE_CODE = 'SET_REGISTER_REFERENCE_CODE'
export const SET_MARKETPLACE = 'SET_MARKETPLACE'
export const SET_INFO_AUTO_TOUCH = 'SET_INFO_AUTO_TOUCH '
export const RESET_EDIT_STATE = 'RESET_EDIT_STATE '
